import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import $ from 'jquery';
import { GetUserLettersToPrint, GetUserById, GetLetterById, DownloadLettersAndReco, GenerateBordereau } from '../../actions/backoffice/impression';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';

import Emptylustration from './../../assets/images/svg/057-contract-1.svg';

import { ImpressionHeader } from './ImpressionHeader';
import { ImpressionTableHeader } from './ImpressionTableHeader';
import { ImpressionTableLine } from './ImpressionTableLine';

import * as Loadings from '../../constants/loadings/backoffice/impression';
import { LoadingState } from '../../_common/loadingState';
// import { AddPartner } from './../_common/AddPartner';

export const Impression = ({ impressionState }) => {
	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const [isLoading, setIsLoading] = useState(false);
	const [selectedDocuments, setSelectedDocuments] = useState([]);

	const [tableLines, setTableLines] = useState([]);
	const [tableLinesToDisplay, setTableLinesToDisplay] = useState([]);
	const [filters, setFilters] = useState({
		order: {
			table: "letter",
			column: "name",
			asc: true
		},
		search: "",
	});

	const pageQuery = new URLSearchParams(searchQuery.search);
	let page = pageQuery.get('page');

	useEffect(() => {
		dispatch(GetUserLettersToPrint(R.isNil(page) ? 1 : page));
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	useEffect(() => {
		const uniqueUserIds = [];
		const uniqueLetterIds = [];

		const promisesUser = [];
		const promisesLetters = [];

		//setSelectedDocuments(impressionState.userLetters.map(u => u.id));

		impressionState.userLetters.map((userLetter) => {
			if (uniqueUserIds.indexOf(userLetter.userId) === -1) {
				uniqueUserIds.push(userLetter.userId);
				promisesUser.push(GetUserById(userLetter.userId));
			}
			if (uniqueLetterIds.indexOf(userLetter.letterId) === -1) {
				uniqueLetterIds.push(userLetter.letterId);
				promisesLetters.push(GetLetterById(userLetter.letterId));
			}
		});

		let users = [];
		let letters = [];
		setIsLoading(true);
		Promise.all(promisesUser)
			.then((userDtos) => {
				users = userDtos;
				Promise.all(promisesLetters)
					.then((letterDtos) => {
						letters = letterDtos;
						const t = [];
						impressionState.userLetters.map((userLetter) => {
							const letter = letters.find(l => l.id === userLetter.letterId);
							letter.name = letter.name.substring(letter.name.indexOf('-') + 1);
							letter.name = letter.name.substr(0, 1).toUpperCase() + letter.name.substring(1);

							t.push({
								userLetter,
								user: users.find(u => u.id === userLetter.userId),
								letter: letter
							});
						});
						setTableLines(t);
						setIsLoading(false);
					});
			});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [impressionState.userLetters]);

	useEffect(() => {

		let temp = [...tableLines];

		if (filters.order.asc) {

			temp = R.sort(R.ascend(R.path([filters.order.table, filters.order.column])), temp);

		} else {

			temp = R.sort(R.descend(R.path([filters.order.table, filters.order.column])), temp);

		}

		if (!R.isEmpty(filters.search)) {
			temp = temp.filter(tl => tl.letter?.name?.toLowerCase().includes(filters.search.toLowerCase()) || tl.user.processNumber.toString().toLowerCase().includes(filters.search.toLowerCase()));

		}

		setTableLinesToDisplay(temp);

	}, [filters, tableLines]);

	// if (impressionState.isLoading.includes(Loadings.FETCHING_USER_LETTERS)) {
	// 	return <LoadingState />;
	// }

	if (R.isEmpty(impressionState.userLetters)) {

		return (
			<section className="block fs-3 text-center m-auto py-4">
				<img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
				<div className="block text-center container-thin mx-auto mb-auto">
					<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas de <br></br> lettres.</h1>
					<p className="o-80 mb-0">L'utilisateur veuillez ajouter un nouvel lettres.</p>
				</div>
			</section>
		);
	}

	return (
		<article className="view-calc pt-4 mb-auto pb-sm">
			<h1 className="sr-only visually-hidden">Backoffice: Print</h1>
			<div className="container-fluid">
				{/* <ImpressionHeader /> */}
				<nav className="navbar navbar-expand-sm navbar-light px-0 mb-xl-2 mt-sm mt-xl-0">
					<h1 className="sr-only visually-hidden">Print: Filter</h1>
					<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
						<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
					</button>
					<div className="collapse navbar-collapse flex-column" id="navbarNav">
						<form className="form-inline container-hd mx-auto justify-content-center">
							{/* <div className="my-1 input-group btn-dim rounded-max mr-2 ml-xl-auto">
								<input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" aria-label="Recherche" value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} />
								<div className="input-group-prepend rounded-inherit">
									<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4"><i className="eva eva-search-outline align-middle fs-root lh-0 o-70 o-100--hover"></i></button>
								</div>
							</div> */}
							{/* <div className="my-1 input-group btn-dim rounded-max mr-2 btn-alert active" role="button">
								<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Les plus récents</p>
								<div className="input-group-prepend rounded-inherit dropdown">
									<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i className="eva eva-funnel-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
									</button>
									<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButton">
										<button className="dropdown-item py-2 h6 mb-0 active" type="button">Les plus récents</button>
										<button className="dropdown-item py-2 h6 mb-0" type="button">Ordre alphabétique</button>
									</div>
								</div>
							</div> */}
							{/* <div className="divider-vertical mx-3"></div> */}
							<button type="button" className="btn btn-white-primary rounded-max p-0 mr-2" disabled={R.isEmpty(selectedDocuments)} onClick={(e) => {
								e.preventDefault();
								DownloadLettersAndReco(selectedDocuments.map((d) => { return { id: d }; }));
							}}>
								<p className="form-control my-auto small ml-2 d-none d-md-inline-block">Télécharger documents</p>
								<div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
									<i className="eva eva-download-outline align-middle fs-root lh-xs"></i>
								</div>
							</button>
							{/* <button type="button" className="btn btn-white-info rounded-max p-0 mr-2" disabled={R.isEmpty(selectedDocuments)} onClick={(e) => {
								e.preventDefault();
								DownloadLettersAndReco(selectedDocuments.map((d) => { return {id: d}}));
							}}>
								<p className="form-control my-auto small ml-2 d-none d-md-inline-block">Générer Bordereau</p>
								<div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
									<i className="eva eva-checkmark-circle-outline align-middle fs-root lh-xs"></i>
								</div>
							</button> */}
							<button type="button" className="btn btn-white-success rounded-max p-0 mr-2" disabled={R.isEmpty(selectedDocuments)} onClick={(e) => {
								e.preventDefault();
								GenerateBordereau(selectedDocuments.map((d) => { return { id: d }; }))
									.then(() => {
										setSelectedDocuments([]);
										dispatch(GetUserLettersToPrint());
									});
							}}>
								<p className="form-control my-auto small ml-2 d-none d-md-inline-block">Générer Bordereau</p>
								<div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
									<i className="eva eva-paper-plane-outline align-middle fs-root lh-xs"></i>
								</div>
							</button>
							{/* <div className="my-1 input-group btn-dim rounded-max mr-2 btn-alert" role="button">
								<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonPoste" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Intitulé du poste</p>
								<div className="input-group-prepend rounded-inherit dropdown">
									<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonPoste" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i className="eva eva-person-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
									</button>
									<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonPoste">
										<button className="dropdown-item py-2 h6 mb-0 active" type="button">Intitulé du poste</button>
										<button className="dropdown-item py-2 h6 mb-0" type="button">Employée</button>
										<button className="dropdown-item py-2 h6 mb-0" type="button">Assistant</button>
										<button className="dropdown-item py-2 h6 mb-0" type="button">Admin</button>
									</div>
								</div>
							</div> */}
						</form>
					</div>
				</nav>
			</div>
			<div className="auto-view h-100 mb-auto">
				<div className="container-fluid h-inherit flex-column">
					{!tableLinesToDisplay.length >= 1 ?
						filters.search.trim() !== "" ?
							<section className="block fs-3 text-center m-auto py-4">
								<img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
								<div className="block text-center container-thin mx-auto mb-auto">
									<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas de <br></br> lettres.</h1>
									<p className="o-80 mb-0">Malheureusement, nous ne parvenons pas à trouver le contenu que vous recherchez.</p>
								</div>
							</section>
							:
							< LoadingState />
						:
						<section className={"block" + (impressionState.isLoading.includes(Loadings.FETCHING_USER_LETTERS) || isLoading ? " h-inherit flex-column" : "")}>
							<h1 className="sr-only visually-hidden">Print: List</h1>
							<header className="db sticky-top z-1 mb-xs">
								<ImpressionTableHeader filters={filters} setFilters={setFilters} selectAll={() => {
									const userLettersToDisplay = tableLinesToDisplay.map(t => t.userLetter.id);
									if (userLettersToDisplay.every(t => selectedDocuments.includes(t))) {
										setSelectedDocuments(selectedDocuments.filter(d => !userLettersToDisplay.includes(d)));
									} else {
										const tempSelectedDocs = selectedDocuments.concat(userLettersToDisplay);
										setSelectedDocuments(R.uniq(tempSelectedDocs));
									}
								}} areAllSelected={tableLinesToDisplay.every(t => selectedDocuments.includes(t.userLetter.id))} selectedDocuments={selectedDocuments.length} setSelectedDocuments={setSelectedDocuments} totalRecords={impressionState.totalRecords} tableLinesToDisplay={tableLinesToDisplay.length} />
								{!R.isNil(selectedDocuments) && selectedDocuments.length > 0 ?
									<div className="flex-column flex-lg-row align-items-center justify-content-center bg-alert-common px-3 py-2 fs-book rounded-sm mt-1">
										<span className="o-70 mx-2"><b className="fw-bold">{selectedDocuments.length}</b>&nbsp;lettres sélectionnées sur un total de&nbsp;<b className="fw-bold">{impressionState.totalRecords}</b>.</span>
										<span id=":n0" className="btn btn-outline-aux p-1 fs-book border-none lh-1 rounded-sm" tabIndex="0" role="link" onClick={() => setSelectedDocuments([])}>Supprimer la sélection</span>
									</div>
									:
									''
								}
							</header>
							{impressionState.isLoading.includes(Loadings.FETCHING_USER_LETTERS) || isLoading ?
								<LoadingState />
								:
								<ul className="block p-0 mb-0">
									{tableLinesToDisplay.map((tableLine) => {
										return (
											<ImpressionTableLine userLetter={tableLine.userLetter} user={tableLine.user} letter={tableLine.letter} key={tableLine.userLetter.id} selectDocuments={selectedDocuments} setSelectedDocuments={setSelectedDocuments} />
										);

									})}
								</ul>
							}
						</section>
					}
				</div>
			</div>
			<div className="container-fluid">
				<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
					{impressionState.currentPage > 1 ? <Link to={`/backoffice/impression?page=${1}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></button>}
					{impressionState.currentPage > 1 ? <Link to={`/backoffice/impression?page=${impressionState.currentPage - 1}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></button>}

					<span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">{impressionState.currentPage} de {impressionState.totalPages}</span>

					{impressionState.currentPage !== impressionState.totalPages ? <Link to={`/backoffice/impression?page=${impressionState.currentPage + 1}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></button>}
					{impressionState.currentPage !== impressionState.totalPages ? <Link to={`/backoffice/impression?page=${impressionState.totalPages}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></button>}
				</nav>
			</div>
		</article>
	);
};